export default __webpack_public_path__ + "547d16331fbf0f77824a5125b27b41f8.png";